<template>
  <v-card v-if="country">
    <slot name="title">
      <v-toolbar color="grey lighten-4" light tile flat>
        <v-toolbar-title centered class="headline font-weight-bold">{{ title }}</v-toolbar-title>
        <div class="flex-grow-1"></div>

        <v-spacer></v-spacer>
        <v-btn color="primary" @click="isUpdating = true">
          <v-icon>mdi-pencil</v-icon>
          Edit
        </v-btn>
      </v-toolbar>
    </slot>

    <v-card-text>
      <v-row>
        <v-col cols="4">
          <key-value title="Id">
            <span class="small" v-text="country.id"></span>
          </key-value>
          <key-value title="Country Name" :value="country.name" />
          <!-- <key-value title="Sending Min Amount (€)" :value="country.sending_min_amount" />
          <key-value title="Sending Max Amount (€)" :value="country.sending_max_amount" />
        </v-col>
        <v-col cols="4">
          <key-value
            title="Receiving Min Amount (€)"
            :value="country.receiving_min_amount"
            type="date"
          />
          <key-value
            title="Receiving Max Amount (€)"
            :value="country.receiving_max_amount"
            type="date"
          />
        </v-col>
        <v-col cols="4">
          <key-value title="Is Sending Country">
            <v-icon color="success" size="35" v-if="country.is_sending_country"
              >mdi-progress-check</v-icon
            >

            <v-icon color="error" size="35" v-else>mdi-progress-close</v-icon>
          </key-value> -->
        </v-col>
      </v-row>
    </v-card-text>
    <update-country-form
      method="put"
      :country.sync="country"
      :is-active.sync="isUpdating"
      @changed="countryUpdated"
    ></update-country-form>
  </v-card>
</template>

<script>
import UpdateCountryForm from "./form";

export default {
  props: {
    dataCountry: Object,
    title: { default: "Crypto Country details" },
    hideActions: { type: Boolean, default: false },
  },
  components: { UpdateCountryForm },
  data() {
    return {
      isUpdating: false,
    };
  },
  computed: {
    country() {
      return this.dataCountry;
    },
  },
  methods: {
    countryUpdated({ country }) {
      this.$emit("updated", country);
      this.isUpdating = false;
    },
  },
};
</script>
